import { render } from "./SelectComponent.vue?vue&type=template&id=3710d67a&scoped=true"
import script from "./SelectComponent.vue?vue&type=script&lang=js"
export * from "./SelectComponent.vue?vue&type=script&lang=js"

import "./SelectComponent.vue?vue&type=style&index=0&id=3710d67a&scoped=true&lang=scss"

import exportComponent from "/var/www/www-root/data/www/malmarket/malmarket-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3710d67a"]])

export default __exports__